import { render, staticRenderFns } from "./KnowAlphaM.vue?vue&type=template&id=0c86fde9&scoped=true&"
import script from "./KnowAlphaM.vue?vue&type=script&lang=js&"
export * from "./KnowAlphaM.vue?vue&type=script&lang=js&"
import style0 from "./KnowAlphaM.vue?vue&type=style&index=0&id=0c86fde9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86fde9",
  null
  
)

export default component.exports